// If change, please update file `.storybook/preview.tsx` accordingly
export const breakpoints = {
  mobileXS: '320px',
  mobileS: '375px',
  mobileSM: '396px',
  mobileM: '425px',
  mobileL: '432px',
  tablet: '768px',
  desktopS: '848px',
  desktop: '1024px',
};
